/* @flow */

export * from './component';



// WEBPACK FOOTER //
// ./src/checkout/index.js